import React from "react";

// Layouts
import MainLayout from "layouts/Main";

// Tools
import { ADVISER_PHONE, INVESTOR_PHONE } from "utils/constants";

// Styles
import "./AccountLockedPage.scss";

export default function AccountLockedPage() {
  return (
    <MainLayout showFooterText={false}>
      <div className="account-locked-content">
        <h1 className="coheadline navyBlue">Your account is now locked</h1>

        <div className="information-block">
          <p>
            Due to failed login attempts your account has now been locked. Please contact us to
            reset your password.{" "}
          </p>
          <p>
            If you're an investor call <u>{INVESTOR_PHONE}</u>
            <br />
            If you’re an adviser call <u>{ADVISER_PHONE}</u>
          </p>
        </div>
      </div>
    </MainLayout>
  );
}
